// extracted by mini-css-extract-plugin
export default {"SiteDarkGrey":"#5A6268","Footer":"Footer_Footer__i2hP4","active":"Footer_active__ZhDWC","MadeIn":"Footer_MadeIn__NCKuu","Link":"Footer_Link__z+CPl"};